import { gql } from '@apollo/client';

/**
 * 批量打印分拣机格口二维码标签（交叉带 / 直线分拣机）。
 * 返回 PDF 的 base64，前端解码后下载/打印（每格口一页，二维码内容为 {sorterCode,chuteCode} JSON）。
 */
export const PRINT_SORTER_CHUTE_LABELS = gql`
    mutation PrintSorterChuteLabels($sorterId: Long!) {
        printSorterChuteLabels(sorterId: $sorterId) {
            success
            message
            pdfBase64
        }
    }
`;
